import { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import useMultiLanguage from '../../hook/useMultiLanguage';
import { checkStatus, formatDateTable, getFullYear } from '../utils/functionUtils';
import { INIT_SEARCH_OBJECT, LIST_MONTH, RESPONSE_STATUS_CODE, TYPE, VARIABLE_STRING } from '../constants/moduleConsts';
import { GroupButton } from '../components/GroupButton';
import "./time-sheet.scss";
import { toast } from 'react-toastify';
import AppContext from '../../AppContext';
import { ITimesheet } from './models/timesheetModels';
import { searchListTimesheet, searchListTimeSheetSchedule } from './services/timesheetServices';
import TableCustom, { columnNamesType } from '../components/table-custom/TableCustom';
import { LIST_STATUS } from '../receiving-citizens/constants/receivingCitizensConsts';
import InputSearch from '../components/input/InputSearch';
import TimesheetForm from './components/TimesheetForm';
import Autocomplete from '../components/input/autocomplete';
import { LIST_TAB_TIMESHEET, REF_TAB_TIMESHEET, TYPE_TIMESHEET } from './constants/timesheetConsts';
import TimesheetOvertimeForm from './components/TimesheetOvertimeForm';
import { LIST_TYPE_SCHEDULE } from '../category/constants/approvalConfigConsts';
import TimesheetScheduleForm from './components/TimesheetScheduleForm';
import moment from 'moment';

function Timesheet() {
	const { lang } = useMultiLanguage();
	const { setPageLoading } = useContext(AppContext);

	const [listTimesheet, setListTimesheet] = useState<ITimesheet[]>([]);
	const [listScheduleTimesheet, setListScheduleTimesheet] = useState<ITimesheet[]>([]);
	const [openTimesheetForm, setOpenOfficeWorkForm] = useState<boolean>();
	const [openTimesheetOvertimeForm, setOpenTimesheetOvertimeForm] = useState<boolean>();
	const [openTimesheetScheduleForm, setOpenTimesheetScheduleForm] = useState<boolean>();
	const [timesheetInfo, setTimesheetInfo] = useState<ITimesheet>({} as ITimesheet);
	const [totalPage, setTotalPage] = useState<number>(0);
	const [totalElements, setTotalElements] = useState<number>(0);
	const [numberOfElements, setNumberOfElements] = useState<number>(0);
	const [searchObject, setSearchObject] = useState<any>({
		...INIT_SEARCH_OBJECT,
		nam: String(new Date().getFullYear())
	});
	const [activeTab, setActiveTab] = useState<string>(REF_TAB_TIMESHEET.TAB_TIMESHEET);

	useEffect(() => {
		setSearchObject({ ...INIT_SEARCH_OBJECT, nam: String(new Date().getFullYear()) });
	}, [activeTab])

	const handleOpenForm = useCallback((info: any) => {
		switch (activeTab) {
			case REF_TAB_TIMESHEET.TAB_OVERTIME:
				setOpenOfficeWorkForm(false);
				setOpenTimesheetScheduleForm(false);
				setOpenTimesheetOvertimeForm(true);
				break;
			case REF_TAB_TIMESHEET.TAB_SCHEDULE:
				setOpenOfficeWorkForm(false);
				setOpenTimesheetOvertimeForm(false);
				setOpenTimesheetScheduleForm(true);
				break;
			default:
				setOpenTimesheetOvertimeForm(false);
				setOpenTimesheetScheduleForm(false);
				setOpenOfficeWorkForm(true);
				break;
		}
		setTimesheetInfo(info);
	}, [activeTab]);

	const handleClose = () => {
		setOpenOfficeWorkForm(false);
		setOpenTimesheetOvertimeForm(false);
		setOpenTimesheetScheduleForm(false);
		setTimesheetInfo({} as ITimesheet);
	};

	const getListOfficeWorkSchedule = async (searchData?: any) => {
		try {
			setPageLoading(true);
			setSearchObject({ ...searchData })
			const { data } = await searchListTimesheet({ ...searchData, type: TYPE_TIMESHEET.CHAM_CONG_THEO_PHONG_BAN });
			if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
				setListTimesheet(data?.data?.content || []);
				setTotalPage(data?.data?.pageable?.totalPages);
				setTotalElements(data?.data?.pageable?.totalElements);
				setNumberOfElements(data?.data?.pageable?.numberOfElements);
			} else {
				toast.warning(data?.message);
			}
		} catch (err) {
			toast.error(lang("GENERAL.ERROR"));
		} finally {
			setPageLoading(false);
		}
	};

	const getListSchedule = async (searchData?: any) => {
		try {
			setPageLoading(true);
			setSearchObject({ ...searchData })
			const { data } = await searchListTimeSheetSchedule({ ...searchData, type: TYPE_TIMESHEET.CHAM_CONG_THEO_DAY_TRUC });
			if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
				setListScheduleTimesheet(data?.data?.content || []);
				setTotalPage(data?.data?.pageable?.totalPages);
				setTotalElements(data?.data?.pageable?.totalElements);
				setNumberOfElements(data?.data?.pageable?.numberOfElements);
			} else {
				toast.warning(data?.message);
			}
		} catch (err) {
			toast.error(lang("GENERAL.ERROR"));
		} finally {
			setPageLoading(false);
		}
	};

	const handleSearch = useCallback((data: any = {}) => {
		const dataSearch: any = {
			...searchObject,
			...data
		};
		dataSearch.keyword = dataSearch?.keyword?.trim() || "";
		if (activeTab === REF_TAB_TIMESHEET.TAB_SCHEDULE) {
			getListSchedule(dataSearch);
		} else {
			getListOfficeWorkSchedule(dataSearch);
		}
	}, [activeTab, searchObject]);

	useEffect(() => {
		if (searchObject?.pageIndex && searchObject?.pageSize) {
			handleSearch();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchObject?.pageIndex, searchObject?.pageSize])

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchObject({
			...searchObject,
			keyword: e.target?.value
		});
	};

	const handleChangeSelect = (name: string, value: any) => {
		switch (name) {
			case VARIABLE_STRING.THANG:
				setSearchObject({
					...searchObject,
					thang: value?.code
				});
				break;
			case VARIABLE_STRING.NAM:
				setSearchObject({
					...searchObject,
					nam: value?.name
				})
		}
	}

	const handleCloseAndSearch = () => {
		handleSearch();
		handleClose();
	}

	const handleTabChange = (key: string | null) => {
		key && setActiveTab(key);
	};

	const columns: columnNamesType[] = [
		{
			name: "STT",
			field: "",
			render: (_row, _index, stt) => <span>{stt}</span>
		},
		{
			name: lang("STATUS"),
			field: "trangThai",
			headerStyle: {
				minWidth: "100px"
			},
			render: (row: any) => (
				<span className={`${checkStatus(LIST_STATUS, Number(row?.trangThai?.code))} status`}>
					{row?.trangThai?.name}
				</span>
			)
		},
		{
			name: lang("INPUT.DEPARTMENTS"),
			field: "phongBanText",
			headerStyle: {
				minWidth: "200px",
			},
			cellStyle: {
				textAlign: "left"
			}
		},
		{
			name: lang("GENERAL.TIME"),
			field: "thoiGian",
			headerStyle: {
				minWidth: "120px"
			},
			render: (row: any) => <span>{row?.thang + "/" + row?.nam}</span>
		},
		{
			name: lang("DATE.APPROVE"),
			field: "ngayDuyet",
			headerStyle: {
				minWidth: "120px"
			},
			render: (row: any) => <span>{formatDateTable(row?.ngayDuyet)}</span>
		},
		{
			name: lang("WELFARE.ACTUAL_COST.APPROVED_PEOPLE"),
			field: "nguoiDuyetText",
			headerStyle: {
				minWidth: "120px"
			},
			cellStyle: {
				textAlign: "left"
			}
		},
	];

	const columnsSchedule: columnNamesType[] = [
		{
			name: "STT",
			field: "",
			render: (_row: any, _index: number, stt: number) => <span>{stt}</span>
		},
		{
			name: lang("SCHEDULE_CONFIG.NAME"),
			field: "dayTrucName",
			headerStyle: {
				minWidth: "200px"
			},
			cellStyle: {
				textAlign: "left"
			},
		},
		{
			name: lang("GENERAL.TIME"),
			field: "thoiGian",
			headerStyle: {
				minWidth: "100px"
			},
			cellStyle: {
				textAlign: "center"
			},
			render: (row: any) => <span>{(row?.thang || "") + "/" + (row?.nam || "")}</span>
		},
	];

	const renderTimesheetForm = () => {
		if (openTimesheetForm) {
			return (
				<TimesheetForm
					handleClose={handleClose}
					timesheetInfo={timesheetInfo}
					handleCloseAndSearch={handleCloseAndSearch}
				/>
			);
		}
		if (openTimesheetOvertimeForm) {
			return (
				<TimesheetOvertimeForm
					handleClose={handleClose}
					timesheetInfo={timesheetInfo}
					handleCloseAndSearch={handleCloseAndSearch}
				/>
			);
		}

		if (openTimesheetScheduleForm) {
			return (
				<TimesheetScheduleForm
					handleClose={handleClose}
					timesheetInfo={timesheetInfo}
					handleCloseAndSearch={handleCloseAndSearch}
				/>
			);
		}
		return null;
	};

	return (
		<div className="time-sheets spaces px-8 py-12 flex-1">
			{(!openTimesheetForm && !openTimesheetOvertimeForm && !openTimesheetScheduleForm) ? (
				<>
					<Row className="spaces mb-12 mt-10 flex-middle flex-space-between relative z-index-3">
						<Col xs={6} xl={7} xxl={7} className="p-0">
							{/* <h2 className="breadcrumb-title">{lang("TIMESHEET.LIST")}</h2> */}
							<Tabs
								activeKey={activeTab}
								defaultActiveKey={REF_TAB_TIMESHEET.TAB_TIMESHEET}
								id="justify-tab-example"
								className="list-tabs list-tabs-timesheet"
								onSelect={handleTabChange}
							>
								{LIST_TAB_TIMESHEET.map((tab, index) => (
									<Tab
										key={`tab-timesheet-${index}`}
										eventKey={tab.id}
										title={lang(tab.nameTab)}
										className="tab-content"
										id={tab.id}
										mountOnEnter
									>
									</Tab>
								))}
							</Tabs>
						</Col>
						<Col xs={6} xl={5} xxl={5} className="flex justify-content-end gap-3">
							<Autocomplete
								className="spaces w-120"
								placeholder={lang("GENERAL.MONTH")}
								name={VARIABLE_STRING.THANG}
								options={LIST_MONTH}
								value={searchObject?.thang || ""}
								valueSearch="code"
								onChange={(selectedOption) => handleChangeSelect(VARIABLE_STRING.THANG, selectedOption)}
							/>
							<Autocomplete
								className="spaces w-100"
								placeholder={lang("GENERAL.YEAR")}
								name={VARIABLE_STRING.NAM}
								options={getFullYear(0, 5)}
								value={searchObject?.nam || ""}
								onChange={(selectedOption) => handleChangeSelect(VARIABLE_STRING.NAM, selectedOption)}
							/>
							<div className="flex-1 spaces max-w-300">
								<InputSearch
									className="border-3px"
									value={searchObject?.keyword}
									placeholder={activeTab === REF_TAB_TIMESHEET.TAB_SCHEDULE ? "Tìm kiếm theo Dây trực" : "Tìm kiếm theo Khoa/Phòng"}
									handleSearch={() => handleSearch({ pageIndex: 1 })}
									handleChange={handleChange}
									isEnter
								/>
							</div>
							<GroupButton handleEvent={() => handleSearch({ pageIndex: 1 })}>
								{lang("BTN.SEARCH")}
							</GroupButton>
						</Col>
					</Row>
					<Row className="bg-white">
						<Col className="table-scroll">
							{activeTab === REF_TAB_TIMESHEET.TAB_SCHEDULE ? (
								<TableCustom
									id="schedule-timekeeping-list"
									data={listScheduleTimesheet}
									columns={columnsSchedule}
									searchObject={searchObject}
									setSearchObject={setSearchObject}
									notDelete={true}
									type={TYPE.MULTILINE}
									totalPages={totalPage}
									totalElements={totalElements}
									numberOfElements={numberOfElements}
									handleDoubleClick={(row: any) => handleOpenForm(row)}
								/>
							) : (

								<TableCustom
									id="office-work-schedule-list"
									data={listTimesheet}
									columns={columns}
									searchObject={searchObject}
									setSearchObject={setSearchObject}
									notDelete={true}
									type={TYPE.MULTILINE}
									totalPages={totalPage}
									totalElements={totalElements}
									numberOfElements={numberOfElements}
									handleDoubleClick={(row: any) => handleOpenForm(row)}
								/>
							)}
						</Col>
					</Row>
				</>
			) : <>{renderTimesheetForm()}</>}
		</div>
	)
}

export default Timesheet
